var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/_metaMap.js
// module id = 683
// module chunks = 0